import ChevronRight from "@redotech/redo-icons/chevron-right.svg";
import { RedoToggle } from "@redotech/redo-web/arbiter-components/toggle/redo-toggle";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import classNames from "classnames";
import { memo } from "react";
import { Link } from "react-router-dom";
import * as styles from "./protection-product-summary.module.css";

export const ProtectionProductSummary = memo(function ProtectionProductSummary({
  title,
  productEnabled,
  coverageEnabled,
  enabledCountries,
  price,
  linkTo,
  setProductEnabled,
}: {
  title: string;
  productEnabled: boolean;
  coverageEnabled: boolean;
  enabledCountries: string[];
  price: string;
  linkTo: string;
  setProductEnabled: (productEnabled: boolean) => void;
}) {
  let enabledCountryText = enabledCountries.length
    ? enabledCountries.join(", ")
    : "All countries";

  if (!coverageEnabled) {
    enabledCountryText = "";
  }

  return (
    <Link to={linkTo}>
      <Flex
        align="stretch"
        className={styles.container}
        dir="column"
        gap="none"
        px="xl"
      >
        <Flex align="stretch" dir="column" gap="none">
          <Flex dir="row" gap="xl" py="xl">
            <Flex align="center" dir="column" gap="none" justify="flex-start">
              <RedoToggle
                onClick={(e) => e.stopPropagation()}
                semantic
                setValue={setProductEnabled}
                size="sm"
                value={productEnabled}
              />
            </Flex>
            <Flex align="stretch" dir="column" gap="xs" grow={1}>
              <Text fontSize="sm" fontWeight="medium" textColor="primary">
                {title}
              </Text>
              <Flex dir="row" gap="xxs">
                <div
                  className={classNames(
                    styles.statusLight,
                    coverageEnabled ? styles.enabled : styles.disabled,
                  )}
                />
                <Flex align="stretch" dir="column" gap="none">
                  <Text fontSize="xs" fontWeight="regular" textColor="tertiary">
                    Coverage {coverageEnabled ? `enabled ${price}` : "disabled"}
                  </Text>
                  <Text fontSize="xs" fontWeight="regular" textColor="tertiary">
                    {enabledCountryText}
                  </Text>
                </Flex>
              </Flex>
            </Flex>
            <Flex align="center" dir="column" gap="none" justify="center">
              <ChevronRight height={20} width={20} />
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Link>
  );
});
